/*
* @Author: tengmaoqing
* @Date:   2018-04-17 11:53:16
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-27 11:14:12
*/
// import parse from 'url-parse';
import createInstance from './instanceCreator';

/**
 * 手动维护 http 实例，每次 new 一个 app 都需要new 一个 http 实例，该方案主要针对 ssr，在尽量少的改动原有代码基础上，实现实例管理
 * 当 运行时间长后 可能 httpId 会很大，导致未知问题。 同一时刻如果 id 重复也可能会有问题
 */
const instances = {};
let httpId = 'init';

export const getHttpId = () => {
  return httpId;
};

export const getHttpInstance = () => {
  return instances[httpId];
};

export const newHttp = config => {
  httpId = Math.random().toString(32).slice(2);
  instances[httpId] = {
    http: createInstance(),
    apiHost: config.apiHost,
    Id: httpId
  };
  return instances[httpId];
};

export const removeHttpInstanceById = (httpId) => {
  instances[httpId] = null;
  delete instances[httpId];
};

export const getProducts = (categoryId, brandId, pageIndex = 1, pageSize = 20) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/product/getProductList?classId=${categoryId}&brandId=${brandId}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
};

export const getProductsByKey = (keyword = '', pageIndex = 1, pageSize = 20) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/product/getProductList?keyword=${keyword}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
};

export const getBrands = (categoryId, pageSize = 100) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/product/getBrandList?classId=${categoryId}&pageSize=${pageSize}`);
};

export const getCategory = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/product/getCategoryList`);
};

export const getProductParams = productId => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/product/getProductParam?productId=${productId}`);
};

export const evaluate = (productId, select) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/product/evaluate?time=${Date.now()}`, {select, productId});
};

export const getEvInfo = evaluateid => {
  // console.log(`getEvInfo: ${evaluateid}`);
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/product/getEvaluateResult?evaluateid=${evaluateid}&time=${new Date().getTime()}`);
};

export const getPayway = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/getPayway`);
};

export const getRecycleNum = (productId) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/product/getRecycleNum?productId=${productId}`);
};

export const createOrder = ({ evaluateid, tel, payType, regionId, recycleType, time, province, city, county, address, activityId, couponId, payAccount, payName, bankName, userName, imei, thirdCouponId, cardNumber, discountAmount, discountInfo, discountId, preOrderId, unionPayNo }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/order/placeOrder`, {
    evaluateid,
    tel,
    payType,
    regionId,
    recycleType,
    time,
    province,
    city,
    county,
    address,
    activityId,
    couponId,
    payAccount,
    payName,
    preOrderId,
    discountId,
    discountInfo,
    discountAmount,
    bankName,
    userName,
    imei,
		unionPayNo,
    // 第三方券ID， vivo 等
    thirdCouponId,
    // 快递柜回收
    cardNumber
  });
};

// 通过估价ID查询订单号
export const getOrderByGid = (gid) => {
	const httpInstances = getHttpInstance();
	return httpInstances.http.get(`${httpInstances.apiHost}/api/order/getOrderByGid?gid=${gid}&t=${Date.now()}`);
};

export const getTempOrder = orderNum => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/order/getOrderResult?orderNum=${orderNum}`);
};

export const getSfCity = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/Common/getSfCity`);
};

export const getHsbCity = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/Common/getHsbCity`);
};

export const supportVisitTime = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/Common/supportVisitTime`);
};

export const getCode = (tel, imgCode) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/getCode`, {tel, imgCode});
};
export const getCaptcha = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/Captcha/generate`);
};
export const verifyCaptcha = (code) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/Captcha/verify?code=${code}`);
};

export const checkLoginStatus = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/user/checkLoginStatus`);
};

export const login = (tel, code, validDays) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/login`, {tel, code, validDays});
};

export const loginByOppoOid = oid => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/oauth/oppoCallBack?jsOauthLogin=1`, {
    oid
  });
};

export const getUserInfo = ntoken => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/getUserInfo?token=${ntoken}`);
};

export const getOrderList = (pageIndex, pageSize, kw = '', type) => {
  kw = String(kw);
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/order/getOrderList?pageIndex=${pageIndex}&pageSize=${pageSize}&kw=${kw}&is_c2b=${type}`);
};

export const getOrderDetail = orderNum => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/order/getOrderInfo?orderNum=${orderNum}`);
};

export const getBannerConfig = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/common/getBannerList`);
};

// 取消订单
export const cancelOrder = orderNum => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/order/cancelOrder?orderNum=${orderNum}`);
};

// 订单备注
export const orderRemark = (orderNum, content) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/order/remark`, {
    orderNum,
    content
  });
};

/**
 * 获取获取价格趋势(http://wiki.huishoubao.net/index.php?s=/101&page_id=1630)
 */
export const getProductPriceTrend = (productId, price) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/product/getPriceHistory?productId=${productId}&price=${price}`);
};

/**
 * 获取回收方式列表
 */
export const getRecycleTypeList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/common/getRecycleTypeList`);
};

/**
 * @desc: 获取本人下单时可以使用的优惠券
 * @mark: 不需要分页
 * @url: http://wiki.huishoubao.net/index.php?s=/101&page_id=1863
 */
export const getAllowCouponList = (productList) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/getAllowCouponList`, { productList });
};

// 获取限时高价机型
export const getLimitedTime = (pageSize = 4) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/product/limitedTime?pageSize=${pageSize}`);
};

// 获取我的优惠券
export const getUserCouponList = ({ pageIndex = 1, pageSize = 50, status = '' }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/coupon/getUserList`, { pageIndex, pageSize, status });
};

// 通过券码领取优惠券/券包
export const addByCode = ({ couponCode }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/coupon/addByCode`, { couponCode });
};

// 领取优惠券或券包
export const addCoupon = ({ id, isCouponParcel = 0, couponInfoShow = 1 }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/coupon/addByUser`, {id, isCouponParcel, couponInfoShow});
};

// 下单历史轮播
export const placeOrderHistory = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/order/placeOrderHistory`);
};

// 通过手机号码获取微信 openid
export const getOpenidByTel = ({ tel }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/getOpenidByTel`, { tel });
};

// 通过pid获取收款方式列表
export const getPayTypeList = ({ recycleType }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/common/getPayTypeList`, { recycleType });
};

// 获取验证登录态方式
export const getCheckLoginWay = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/getCheckLoginWay`);
};

// 绑定手机号码
export const bindTel = ({ code, tel, changBind }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/bind`, { code, tel, changBind });
};

// 更换手机号码
export const updateUserTel = ({ code, tel }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/updateUserTel`, { code, tel });
};

// 获取活动机型
export const getActivityProducts = (id) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/open/getProductList?templateId=${id}`);
};

// 查看该手机号用户是否已存在
export const queryUserExist = ({ tel }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/queryUserExist`, { tel });
};

// 获取PC首页导航数据
export const getCategoryBrandList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/product/getCategoryBrandList`);
};

export const getEvaluateHistoryTopH5 = type => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/product/topCoprate?type=${type}`);
};

// 获取流水记录（积分/余额/冻结金额）http://wiki.huishoubao.net/index.php?s=/101&page_id=4386
export const getTransList = ({ type, pageIndex, pageSize, returnAmount }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/wallet/getTransList?type=${type}&=pageIndex=${pageIndex}&pageSize=${pageSize}&returnAmount=${returnAmount}`);
};

// 查询钱包金额信息 http://wiki.huishoubao.net/index.php?s=/101&page_id=4510
export const getBalanceInfo = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/wallet/getBalanceInfo`);
};

// 提交订单时, 根据手机号码查询缓存的微信公众号openid或支付宝openid
// http://wiki.huishoubao.net/index.php?s=/101&page_id=4609
export const getCacheInfoByTel = (tel, oauthSite) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/oauth/getInfo`, { tel, oauthSite });
};

// 生成支付宝、微信网页授权二维码接口
export const getOauthCode = (tel, oauthSite, redirectUri) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/qrc/getOauthCode`, { tel, oauthSite, redirectUri });
};

// 生成支付宝、微信网页授权二维码接口
export const getOauthCodeUri = (tel, oauthSite, redirectUri) => {
  const httpInstances = getHttpInstance();
  return `${httpInstances.apiHost}/api/qrc/getOauthCode?tel=${tel}&oauthSite=${oauthSite}&redirectUri=${redirectUri}`;
};

// 获取安卓app 下载地址 http://wiki.huishoubao.net/index.php?s=/101&page_id=4152
export const getAndroidAppDownloadUrl = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/common/checkUpdateAndroid?app=2c-hsb&platform=6`);
};

export const getWxJsSign = (url) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/open/getJsSign?url=${url}`);
};
export const getSupportNum = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/open/getSupportNum`);
};

// export const getConf = key => {
//   const httpInstances = getHttpInstance();
//   return httpInstances.http.get(`https://coo-cnf.huishoubao.com/getConf?key=${key}`);
// };

export const getAcitveConf = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/Coupon/get15Coupons`);
};

export const GetCouponById = (id, isCouponParcel = '0') => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/Coupon/GetCouponNum`, {id, isCouponParcel});
};

// 签到功能
export const sign = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/wallet/sign`);
};

// 查询签到状态
// http://wiki.huishoubao.net/index.php?s=/101&page_id=4840
export const getSignStatus = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/wallet/getSignStatus`);
};

// 获取签到页信息
// http://wiki.huishoubao.net/index.php?s=/101&page_id=4849
export const getSignInfo = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/wallet/getSignInfo`);
};

// 获取签到页信息
// http://wiki.huishoubao.net/index.php?s=/101&page_id=4843
export const getSignList = (year, month) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/wallet/getSignList?month=${month}&year=${year}`);
};

// 上传图片签名
export const createUpdateSign = ({ fileName, path = '/iosjc/dev/', customPath = '/huanbaoshare/', uploadWay = 'tencentUpload' }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/upload/getSign?path=${path}&customPath=${customPath}&uploadWay=${uploadWay}&fileName=${fileName}`);
};

// 生成带参数的小程序二维码
// http://wiki.huishoubao.net/index.php?s=/101&page_id=4980
export const getWXACodeUnlimit = ({ scene, page, width }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/wechat/getWXACodeUnlimit?scene=${scene}&page=${page}&width=${width}`);
};

// 获取生成环保证书的人数
// http://wiki.huishoubao.net/index.php?s=/101&page_id=4981
export const getJoinNum = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/getJoinNum`);
};

// 查询用户积分余额
export const getUserIntegralAmount = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/wallet/getBalanceInfo`);
};

// 查询获奖用户列表
export const getPrizeUser = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/prize/getPrizeUserList`);
};

// 抽奖
export const postPrize = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/prize/luck`);
};

// 兑奖
export const getPrize = (obj) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/prize/exchange`, {
    orderNum: obj.orderNum,
    userName: obj.userName,
    tel: obj.tel,
    address: obj.address
  });
};

// 查询奖品详情
export const getPrizeInfo = (obj) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/prize/getOrderInfo?orderNum=${obj.orderNum}`);
};

// 查询奖品列报
export const getPrizeList = (obj) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/prize/getOrderList?pageIndex=${obj.pageIndex}&pageSize=${obj.pageSize}`);
};

// 根据广告位置获取banner列表
export const getPositionBannerList = (positionCode, platform = 5) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/common/getPositionBannerList?positionCode=${positionCode}&platform=${platform}`);
};

// 查看用户是否领取了环保证书
export const isGenerateCertificate = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/isGenerateCertificate`);
};

// 查询是否已经领取过优惠券，同一个手机号在自有渠道只能领取一次
// http://wiki.huishoubao.net/index.php?s=/101&page_id=5045
export const couponGetReceivedStatus = ({ id, isCouponParcel }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/coupon/getReceivedStatus?id=${id}&isCouponParcel=${isCouponParcel}`);
};

// 保存用户环保证书url
export const saveCertificateUrl = (path) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/saveCertificateUrl?path=${path}`);
};

// 获取环保证书url接口
export const getCertificateUrl = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/getCertificateUrl`);
};
// --------------------------------------------------------------------------------------- 红包助力相关接口 start

// 获取用户是否领取过活动红包
export const rewardGetActivityRewardStatus = (activityId) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/getActivityRewardStatus?activityId=${activityId}`);
};

// 获取用户任务列表
export const rewardGetTaskList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/getTaskList`);
};

// 获取提现用户列表
export const rewardGetWithdrawUserList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/getWithdrawUserList`);
};

// 助力活动详情
export const rewardGetAssistInfo = (assistCode) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/getAssistInfo?assistCode=${assistCode}`);
};

// 获取分享助力唯一编号
export const rewardGetShareAssistCode = activityId => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/getShareAssistCode?activityId=${activityId}`);
};

// 获取助力活动高倍数用户列表
export const rewardGetAssistUserList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/getAssistUserList`);
};

// 助力翻倍
export const rewardAssist = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/assist`, params);
};

// 助力活动详情
export const getAssistInfo = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/getAssistInfo`, params);
};

// 清理活动数据
export const clearAssistInfo = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/clearActivityData`);
};
// --------------------------------------------------------------------------------------- 红包助力相关接口 end

// 获取支行信息
export const getBranchBankInfo = (bankProvinceId, bankCityId, bankId) => {
  const httpInstance = getHttpInstance();
  return httpInstance.http.get(`${httpInstance.apiHost}/api/common/getBranchBankInfo?bankProvinceId=${bankProvinceId}&bankCityId=${bankCityId}&bankId=${bankId}`);
}

// 招行解密登录
export const zhLogin = (d, s) => {
  const httpInstance = getHttpInstance();
  return httpInstance.http.get(`${httpInstance.apiHost}/api/oauth/merchantsBankLogin?data=${d}&sign=${s}`)
}
